export default "/static/images/claim-popup/5.png"